module.exports = __webpack_public_path__ + "media/images/sanders.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/media/images/sanders.jpg
 ** module id = 36
 ** module chunks = 0
 **/